<script>
import XMark from "@/Components/Icons/XMark.vue";
import CheckMark from "@/Components/Icons/CheckMark.vue";

export default {
    components: {CheckMark, XMark},

    props: {
        condition: {
            type: Boolean,
            required: true,
        },
    }
}
</script>

<template>
    <CheckMark v-if="condition" />
    <XMark v-if="! condition"/>
</template>
